import React from 'react';

import { APP_VERSION } from '../../utils';
import { CHANGELOG_RELEASES } from './changelog-data';
import ChangelogView from './changelog-view';

const Changelog = () => (
  <ChangelogView
    title="Changelog Front-end"
    description="Histórico das entregas recentes do CCO, com foco em operação, telemetria, simulador, gestão de ativos e melhorias de interface."
    currentVersion={APP_VERSION}
    releases={CHANGELOG_RELEASES}
  />
);

export default Changelog;
